import axios from 'axios';
import store from './store';

// axios 配置
// axios.defaults.timeout = 5000;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = '/api'

// http request 拦截器
axios.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem('authenticated');

    let apiPrefix = config.url.match(/^[^\/]*\//);
    if (config.method === "put" || config.method === "patch" || config.method === "delete") {
      config.url = config.url.replace(
        /^[^\/]*\//,
        `${apiPrefix}post2rest/${config.method}/`
      );
      config.method = "post";
    }
    // let token = store.state.user ? store.state.user.token : null;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      store.state.isLoading = false;
      switch (error.response.status) {
        case 401:
          store.dispatch('logout');
          break;
        case 400:
          store.dispatch('alert', {
            message: error.response.data.message,
            color: 'error'
          });
          break;
      }
    }
    return Promise.reject(error.response.data);
  }
);

export default axios;
